<template>
  <div class="animated fadeIn">
    <b-card 
      id="new47" 
      no-body
    >
      <div slot="header">
        <i class="fa fa-font-awesome" /> 50 New Icons in 4.7
      </div>
      <b-card-body>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-address-book fa-lg mt-4" /><br>address-book
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-address-book-o fa-lg mt-4" /><br>address-book-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-address-card fa-lg mt-4" /><br>address-card
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-address-card-o fa-lg mt-4" /><br>address-card-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bandcamp fa-lg mt-4" /><br>bandcamp
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bath fa-lg mt-4" /><br>bath
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bathtub fa-lg mt-4" /><br>bathtub <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-drivers-license fa-lg mt-4" /><br>drivers-license <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-drivers-license-o fa-lg mt-4" /><br>drivers-license-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-eercast fa-lg mt-4" /><br>eercast
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-envelope-open fa-lg mt-4" /><br>envelope-open
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-envelope-open-o fa-lg mt-4" /><br>envelope-open-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-etsy fa-lg mt-4" /><br>etsy
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-free-code-camp fa-lg mt-4" /><br>free-code-camp
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-grav fa-lg mt-4" /><br>grav
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-handshake-o fa-lg mt-4" /><br>handshake-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-id-badge fa-lg mt-4" /><br>id-badge
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-id-card fa-lg mt-4" /><br>id-card
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-id-card-o fa-lg mt-4" /><br>id-card-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-imdb fa-lg mt-4" /><br>imdb
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-linode fa-lg mt-4" /><br>linode
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-meetup fa-lg mt-4" /><br>meetup
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-microchip fa-lg mt-4" /><br>microchip
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-podcast fa-lg mt-4" /><br>podcast
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-quora fa-lg mt-4" /><br>quora
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-ravelry fa-lg mt-4" /><br>ravelry
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-s15 fa-lg mt-4" /><br>s15 <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-shower fa-lg mt-4" /><br>shower
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-snowflake-o fa-lg mt-4" /><br>snowflake-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-superpowers fa-lg mt-4" /><br>superpowers
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-telegram fa-lg mt-4" /><br>telegram
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thermometer fa-lg mt-4" /><br>thermometer <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thermometer-0 fa-lg mt-4" /><br>thermometer-0 <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thermometer-1 fa-lg mt-4" /><br>thermometer-1 <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thermometer-2 fa-lg mt-4" /><br>thermometer-2 <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thermometer-3 fa-lg mt-4" /><br>thermometer-3 <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thermometer-4 fa-lg mt-4" /><br>thermometer-4 <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thermometer-empty fa-lg mt-4" /><br>thermometer-empty
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thermometer-full fa-lg mt-4" /><br>thermometer-full
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thermometer-half fa-lg mt-4" /><br>thermometer-half
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thermometer-quarter fa-lg mt-4" /><br>thermometer-quarter
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thermometer-three-quarters fa-lg mt-4" /><br>thermometer-three-quarters
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-times-rectangle fa-lg mt-4" /><br>times-rectangle <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-times-rectangle-o fa-lg mt-4" /><br>times-rectangle-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-user-circle fa-lg mt-4" /><br>user-circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-user-circle-o fa-lg mt-4" /><br>user-circle-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-user-o fa-lg mt-4" /><br>user-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-vcard fa-lg mt-4" /><br>vcard <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-vcard-o fa-lg mt-4" /><br>vcard-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-window-close fa-lg mt-4" /><br>window-close
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-window-close-o fa-lg mt-4" /><br>window-close-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-window-maximize fa-lg mt-4" /><br>window-maximize
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-window-minimize fa-lg mt-4" /><br>window-minimize
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-window-restore fa-lg mt-4" /><br>window-restore
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-wpexplorer fa-lg mt-4" /><br>wpexplorer
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card 
      id="new" 
      no-body
    >
      <div slot="header">
        20 New Icons in 4.5
      </div>
      <b-card-body>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bluetooth fa-lg mt-4" /><br>bluetooth
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bluetooth-b fa-lg mt-4" /><br>bluetooth-b
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-codiepie fa-lg mt-4" /><br>codiepie
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-credit-card-alt fa-lg mt-4" /><br>credit-card-alt
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-edge fa-lg mt-4" /><br>edge
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-fort-awesome fa-lg mt-4" /><br>fort-awesome
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hashtag fa-lg mt-4" /><br>hashtag
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-mixcloud fa-lg mt-4" /><br>mixcloud
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-modx fa-lg mt-4" /><br>modx
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-pause-circle fa-lg mt-4" /><br>pause-circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-pause-circle-o fa-lg mt-4" /><br>pause-circle-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-percent fa-lg mt-4" /><br>percent
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-product-hunt fa-lg mt-4" /><br>product-hunt
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-reddit-alien fa-lg mt-4" /><br>reddit-alien
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-scribd fa-lg mt-4" /><br>scribd
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-shopping-bag fa-lg mt-4" /><br>shopping-bag
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-shopping-basket fa-lg mt-4" /><br>shopping-basket
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-stop-circle fa-lg mt-4" /><br>stop-circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-stop-circle-o fa-lg mt-4" /><br>stop-circle-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-usb fa-lg mt-4" /><br>usb
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card 
      id="web-application" 
      no-body
    >
      <div slot="header">
        Web Application Icons
      </div>
      <b-card-body>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-adjust fa-lg mt-4" /><br>adjust
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-anchor fa-lg mt-4" /><br>anchor
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-archive fa-lg mt-4" /><br>archive
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-area-chart fa-lg mt-4" /><br>area-chart
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrows fa-lg mt-4" /><br>arrows
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrows-h fa-lg mt-4" /><br>arrows-h
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrows-v fa-lg mt-4" /><br>arrows-v
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-asterisk fa-lg mt-4" /><br>asterisk
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-at fa-lg mt-4" /><br>at
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-automobile fa-lg mt-4" /><br>automobile <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-balance-scale fa-lg mt-4" /><br>balance-scale
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-ban fa-lg mt-4" /><br>ban
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bank fa-lg mt-4" /><br>bank <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bar-chart fa-lg mt-4" /><br>bar-chart
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bar-chart-o fa-lg mt-4" /><br>bar-chart-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-barcode fa-lg mt-4" /><br>barcode
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bars fa-lg mt-4" /><br>bars
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-battery-0 fa-lg mt-4" /><br>battery-0 <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-battery-1 fa-lg mt-4" /><br>battery-1 <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-battery-2 fa-lg mt-4" /><br>battery-2 <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-battery-3 fa-lg mt-4" /><br>battery-3 <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-battery-4 fa-lg mt-4" /><br>battery-4 <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-battery-empty fa-lg mt-4" /><br>battery-empty
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-battery-full fa-lg mt-4" /><br>battery-full
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-battery-half fa-lg mt-4" /><br>battery-half
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-battery-quarter fa-lg mt-4" /><br>battery-quarter
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-battery-three-quarters fa-lg mt-4" /><br>battery-three-quarters
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bed fa-lg mt-4" /><br>bed
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-beer fa-lg mt-4" /><br>beer
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bell fa-lg mt-4" /><br>bell
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bell-o fa-lg mt-4" /><br>bell-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bell-slash fa-lg mt-4" /><br>bell-slash
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bell-slash-o fa-lg mt-4" /><br>bell-slash-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bicycle fa-lg mt-4" /><br>bicycle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-binoculars fa-lg mt-4" /><br>binoculars
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-birthday-cake fa-lg mt-4" /><br>birthday-cake
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bluetooth fa-lg mt-4" /><br>bluetooth
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bluetooth-b fa-lg mt-4" /><br>bluetooth-b
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bolt fa-lg mt-4" /><br>bolt
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bomb fa-lg mt-4" /><br>bomb
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-book fa-lg mt-4" /><br>book
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bookmark fa-lg mt-4" /><br>bookmark
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bookmark-o fa-lg mt-4" /><br>bookmark-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-briefcase fa-lg mt-4" /><br>briefcase
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bug fa-lg mt-4" /><br>bug
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-building fa-lg mt-4" /><br>building
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-building-o fa-lg mt-4" /><br>building-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bullhorn fa-lg mt-4" /><br>bullhorn
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bullseye fa-lg mt-4" /><br>bullseye
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bus fa-lg mt-4" /><br>bus
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cab fa-lg mt-4" /><br>cab <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-calculator fa-lg mt-4" /><br>calculator
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-calendar fa-lg mt-4" /><br>calendar
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-calendar-check-o fa-lg mt-4" /><br>calendar-check-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-calendar-minus-o fa-lg mt-4" /><br>calendar-minus-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-calendar-o fa-lg mt-4" /><br>calendar-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-calendar-plus-o fa-lg mt-4" /><br>calendar-plus-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-calendar-times-o fa-lg mt-4" /><br>calendar-times-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-camera fa-lg mt-4" /><br>camera
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-camera-retro fa-lg mt-4" /><br>camera-retro
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-car fa-lg mt-4" /><br>car
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-caret-square-o-down fa-lg mt-4" /><br>caret-square-o-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-caret-square-o-left fa-lg mt-4" /><br>caret-square-o-left
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-caret-square-o-right fa-lg mt-4" /><br>caret-square-o-right
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-caret-square-o-up fa-lg mt-4" /><br>caret-square-o-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cart-arrow-down fa-lg mt-4" /><br>cart-arrow-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cart-plus fa-lg mt-4" /><br>cart-plus
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc fa-lg mt-4" /><br>cc
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-certificate fa-lg mt-4" /><br>certificate
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-check fa-lg mt-4" /><br>check
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-check-circle fa-lg mt-4" /><br>check-circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-check-circle-o fa-lg mt-4" /><br>check-circle-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-check-square fa-lg mt-4" /><br>check-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-check-square-o fa-lg mt-4" /><br>check-square-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-child fa-lg mt-4" /><br>child
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-circle fa-lg mt-4" /><br>circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-circle-o fa-lg mt-4" /><br>circle-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-circle-o-notch fa-lg mt-4" /><br>circle-o-notch
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-circle-thin fa-lg mt-4" /><br>circle-thin
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-clock-o fa-lg mt-4" /><br>clock-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-clone fa-lg mt-4" /><br>clone
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-close fa-lg mt-4" /><br>close <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cloud fa-lg mt-4" /><br>cloud
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cloud-download fa-lg mt-4" /><br>cloud-download
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cloud-upload fa-lg mt-4" /><br>cloud-upload
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-code fa-lg mt-4" /><br>code
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-code-fork fa-lg mt-4" /><br>code-fork
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-coffee fa-lg mt-4" /><br>coffee
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cog fa-lg mt-4" /><br>cog
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cogs fa-lg mt-4" /><br>cogs
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-comment fa-lg mt-4" /><br>comment
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-comment-o fa-lg mt-4" /><br>comment-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-commenting fa-lg mt-4" /><br>commenting
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-commenting-o fa-lg mt-4" /><br>commenting-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-comments fa-lg mt-4" /><br>comments
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-comments-o fa-lg mt-4" /><br>comments-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-compass fa-lg mt-4" /><br>compass
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-copyright fa-lg mt-4" /><br>copyright
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-creative-commons fa-lg mt-4" /><br>creative-commons
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-credit-card fa-lg mt-4" /><br>credit-card
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-credit-card-alt fa-lg mt-4" /><br>credit-card-alt
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-crop fa-lg mt-4" /><br>crop
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-crosshairs fa-lg mt-4" /><br>crosshairs
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cube fa-lg mt-4" /><br>cube
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cubes fa-lg mt-4" /><br>cubes
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cutlery fa-lg mt-4" /><br>cutlery
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-dashboard fa-lg mt-4" /><br>dashboard <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-database fa-lg mt-4" /><br>database
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-desktop fa-lg mt-4" /><br>desktop
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-diamond fa-lg mt-4" /><br>diamond
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-dot-circle-o fa-lg mt-4" /><br>dot-circle-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-download fa-lg mt-4" /><br>download
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-edit fa-lg mt-4" /><br>edit <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-ellipsis-h fa-lg mt-4" /><br>ellipsis-h
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-ellipsis-v fa-lg mt-4" /><br>ellipsis-v
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-envelope fa-lg mt-4" /><br>envelope
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-envelope-o fa-lg mt-4" /><br>envelope-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-envelope-square fa-lg mt-4" /><br>envelope-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-eraser fa-lg mt-4" /><br>eraser
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-exchange fa-lg mt-4" /><br>exchange
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-exclamation fa-lg mt-4" /><br>exclamation
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-exclamation-circle fa-lg mt-4" /><br>exclamation-circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-exclamation-triangle fa-lg mt-4" /><br>exclamation-triangle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-external-link fa-lg mt-4" /><br>external-link
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-external-link-square fa-lg mt-4" /><br>external-link-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-eye fa-lg mt-4" /><br>eye
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-eye-slash fa-lg mt-4" /><br>eye-slash
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-eyedropper fa-lg mt-4" /><br>eyedropper
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-fax fa-lg mt-4" /><br>fax
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-feed fa-lg mt-4" /><br>feed <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-female fa-lg mt-4" /><br>female
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-fighter-jet fa-lg mt-4" /><br>fighter-jet
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-archive-o fa-lg mt-4" /><br>file-archive-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-audio-o fa-lg mt-4" /><br>file-audio-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-code-o fa-lg mt-4" /><br>file-code-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-excel-o fa-lg mt-4" /><br>file-excel-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-image-o fa-lg mt-4" /><br>file-image-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-movie-o fa-lg mt-4" /><br>file-movie-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-pdf-o fa-lg mt-4" /><br>file-pdf-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-photo-o fa-lg mt-4" /><br>file-photo-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-picture-o fa-lg mt-4" /><br>file-picture-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-powerpoint-o fa-lg mt-4" /><br>file-powerpoint-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-sound-o fa-lg mt-4" /><br>file-sound-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-video-o fa-lg mt-4" /><br>file-video-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-word-o fa-lg mt-4" /><br>file-word-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-zip-o fa-lg mt-4" /><br>file-zip-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-film fa-lg mt-4" /><br>film
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-filter fa-lg mt-4" /><br>filter
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-fire fa-lg mt-4" /><br>fire
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-fire-extinguisher fa-lg mt-4" /><br>fire-extinguisher
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-flag fa-lg mt-4" /><br>flag
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-flag-checkered fa-lg mt-4" /><br>flag-checkered
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-flag-o fa-lg mt-4" /><br>flag-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-flash fa-lg mt-4" /><br>flash <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-flask fa-lg mt-4" /><br>flask
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-folder fa-lg mt-4" /><br>folder
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-folder-o fa-lg mt-4" /><br>folder-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-folder-open fa-lg mt-4" /><br>folder-open
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-folder-open-o fa-lg mt-4" /><br>folder-open-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-frown-o fa-lg mt-4" /><br>frown-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-futbol-o fa-lg mt-4" /><br>futbol-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-gamepad fa-lg mt-4" /><br>gamepad
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-gavel fa-lg mt-4" /><br>gavel
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-gear fa-lg mt-4" /><br>gear <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-gears fa-lg mt-4" /><br>gears <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-gift fa-lg mt-4" /><br>gift
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-glass fa-lg mt-4" /><br>glass
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-globe fa-lg mt-4" /><br>globe
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-graduation-cap fa-lg mt-4" /><br>graduation-cap
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-group fa-lg mt-4" /><br>group <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-grab-o fa-lg mt-4" /><br>hand-grab-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-lizard-o fa-lg mt-4" /><br>hand-lizard-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-paper-o fa-lg mt-4" /><br>hand-paper-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-peace-o fa-lg mt-4" /><br>hand-peace-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-pointer-o fa-lg mt-4" /><br>hand-pointer-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-rock-o fa-lg mt-4" /><br>hand-rock-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-scissors-o fa-lg mt-4" /><br>hand-scissors-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-spock-o fa-lg mt-4" /><br>hand-spock-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-stop-o fa-lg mt-4" /><br>hand-stop-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hashtag fa-lg mt-4" /><br>hashtag
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hdd-o fa-lg mt-4" /><br>hdd-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-headphones fa-lg mt-4" /><br>headphones
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-heart fa-lg mt-4" /><br>heart
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-heart-o fa-lg mt-4" /><br>heart-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-heartbeat fa-lg mt-4" /><br>heartbeat
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-history fa-lg mt-4" /><br>history
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-home fa-lg mt-4" /><br>home
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hotel fa-lg mt-4" /><br>hotel <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hourglass fa-lg mt-4" /><br>hourglass
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hourglass-1 fa-lg mt-4" /><br>hourglass-1 <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hourglass-2 fa-lg mt-4" /><br>hourglass-2 <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hourglass-3 fa-lg mt-4" /><br>hourglass-3 <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hourglass-end fa-lg mt-4" /><br>hourglass-end
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hourglass-half fa-lg mt-4" /><br>hourglass-half
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hourglass-o fa-lg mt-4" /><br>hourglass-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hourglass-start fa-lg mt-4" /><br>hourglass-start
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-i-cursor fa-lg mt-4" /><br>i-cursor
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-image fa-lg mt-4" /><br>image <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-inbox fa-lg mt-4" /><br>inbox
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-industry fa-lg mt-4" /><br>industry
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-info fa-lg mt-4" /><br>info
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-info-circle fa-lg mt-4" /><br>info-circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-institution fa-lg mt-4" /><br>institution <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-key fa-lg mt-4" /><br>key
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-keyboard-o fa-lg mt-4" /><br>keyboard-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-language fa-lg mt-4" /><br>language
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-laptop fa-lg mt-4" /><br>laptop
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-leaf fa-lg mt-4" /><br>leaf
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-legal fa-lg mt-4" /><br>legal <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-lemon-o fa-lg mt-4" /><br>lemon-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-level-down fa-lg mt-4" /><br>level-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-level-up fa-lg mt-4" /><br>level-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-life-bouy fa-lg mt-4" /><br>life-bouy <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-life-buoy fa-lg mt-4" /><br>life-buoy <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-life-ring fa-lg mt-4" /><br>life-ring
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-life-saver fa-lg mt-4" /><br>life-saver <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-lightbulb-o fa-lg mt-4" /><br>lightbulb-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-line-chart fa-lg mt-4" /><br>line-chart
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-location-arrow fa-lg mt-4" /><br>location-arrow
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-lock fa-lg mt-4" /><br>lock
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-magic fa-lg mt-4" /><br>magic
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-magnet fa-lg mt-4" /><br>magnet
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-mail-forward fa-lg mt-4" /><br>mail-forward <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-mail-reply fa-lg mt-4" /><br>mail-reply <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-mail-reply-all fa-lg mt-4" /><br>mail-reply-all <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-male fa-lg mt-4" /><br>male
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-map fa-lg mt-4" /><br>map
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-map-marker fa-lg mt-4" /><br>map-marker
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-map-o fa-lg mt-4" /><br>map-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-map-pin fa-lg mt-4" /><br>map-pin
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-map-signs fa-lg mt-4" /><br>map-signs
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-meh-o fa-lg mt-4" /><br>meh-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-microphone fa-lg mt-4" /><br>microphone
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-microphone-slash fa-lg mt-4" /><br>microphone-slash
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-minus fa-lg mt-4" /><br>minus
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-minus-circle fa-lg mt-4" /><br>minus-circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-minus-square fa-lg mt-4" /><br>minus-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-minus-square-o fa-lg mt-4" /><br>minus-square-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-mobile fa-lg mt-4" /><br>mobile
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-mobile-phone fa-lg mt-4" /><br>mobile-phone <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-money fa-lg mt-4" /><br>money
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-moon-o fa-lg mt-4" /><br>moon-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-mortar-board fa-lg mt-4" /><br>mortar-board <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-motorcycle fa-lg mt-4" /><br>motorcycle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-mouse-pointer fa-lg mt-4" /><br>mouse-pointer
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-music fa-lg mt-4" /><br>music
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-navicon fa-lg mt-4" /><br>navicon <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-newspaper-o fa-lg mt-4" /><br>newspaper-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-object-group fa-lg mt-4" /><br>object-group
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-object-ungroup fa-lg mt-4" /><br>object-ungroup
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-paint-brush fa-lg mt-4" /><br>paint-brush
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-paper-plane fa-lg mt-4" /><br>paper-plane
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-paper-plane-o fa-lg mt-4" /><br>paper-plane-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-paw fa-lg mt-4" /><br>paw
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-pencil fa-lg mt-4" /><br>pencil
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-pencil-square fa-lg mt-4" /><br>pencil-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-pencil-square-o fa-lg mt-4" /><br>pencil-square-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-percent fa-lg mt-4" /><br>percent
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-phone fa-lg mt-4" /><br>phone
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-phone-square fa-lg mt-4" /><br>phone-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-photo fa-lg mt-4" /><br>photo <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-picture-o fa-lg mt-4" /><br>picture-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-pie-chart fa-lg mt-4" /><br>pie-chart
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-plane fa-lg mt-4" /><br>plane
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-plug fa-lg mt-4" /><br>plug
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-plus fa-lg mt-4" /><br>plus
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-plus-circle fa-lg mt-4" /><br>plus-circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-plus-square fa-lg mt-4" /><br>plus-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-plus-square-o fa-lg mt-4" /><br>plus-square-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-power-off fa-lg mt-4" /><br>power-off
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-print fa-lg mt-4" /><br>print
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-puzzle-piece fa-lg mt-4" /><br>puzzle-piece
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-qrcode fa-lg mt-4" /><br>qrcode
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-question fa-lg mt-4" /><br>question
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-question-circle fa-lg mt-4" /><br>question-circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-quote-left fa-lg mt-4" /><br>quote-left
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-quote-right fa-lg mt-4" /><br>quote-right
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-random fa-lg mt-4" /><br>random
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-recycle fa-lg mt-4" /><br>recycle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-refresh fa-lg mt-4" /><br>refresh
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-registered fa-lg mt-4" /><br>registered
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-remove fa-lg mt-4" /><br>remove <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-reorder fa-lg mt-4" /><br>reorder <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-reply fa-lg mt-4" /><br>reply
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-reply-all fa-lg mt-4" /><br>reply-all
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-retweet fa-lg mt-4" /><br>retweet
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-road fa-lg mt-4" /><br>road
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-rocket fa-lg mt-4" /><br>rocket
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-rss fa-lg mt-4" /><br>rss
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-rss-square fa-lg mt-4" /><br>rss-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-search fa-lg mt-4" /><br>search
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-search-minus fa-lg mt-4" /><br>search-minus
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-search-plus fa-lg mt-4" /><br>search-plus
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-send fa-lg mt-4" /><br>send <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-send-o fa-lg mt-4" /><br>send-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-server fa-lg mt-4" /><br>server
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-share fa-lg mt-4" /><br>share
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-share-alt fa-lg mt-4" /><br>share-alt
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-share-alt-square fa-lg mt-4" /><br>share-alt-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-share-square fa-lg mt-4" /><br>share-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-share-square-o fa-lg mt-4" /><br>share-square-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-shield fa-lg mt-4" /><br>shield
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-ship fa-lg mt-4" /><br>ship
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-shopping-bag fa-lg mt-4" /><br>shopping-bag
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-shopping-basket fa-lg mt-4" /><br>shopping-basket
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-shopping-cart fa-lg mt-4" /><br>shopping-cart
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sign-in fa-lg mt-4" /><br>sign-in
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sign-out fa-lg mt-4" /><br>sign-out
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-signal fa-lg mt-4" /><br>signal
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sitemap fa-lg mt-4" /><br>sitemap
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sliders fa-lg mt-4" /><br>sliders
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-smile-o fa-lg mt-4" /><br>smile-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-soccer-ball-o fa-lg mt-4" /><br>soccer-ball-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sort fa-lg mt-4" /><br>sort
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sort-alpha-asc fa-lg mt-4" /><br>sort-alpha-asc
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sort-alpha-desc fa-lg mt-4" /><br>sort-alpha-desc
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sort-amount-asc fa-lg mt-4" /><br>sort-amount-asc
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sort-amount-desc fa-lg mt-4" /><br>sort-amount-desc
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sort-asc fa-lg mt-4" /><br>sort-asc
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sort-desc fa-lg mt-4" /><br>sort-desc
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sort-down fa-lg mt-4" /><br>sort-down <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sort-numeric-asc fa-lg mt-4" /><br>sort-numeric-asc
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sort-numeric-desc fa-lg mt-4" /><br>sort-numeric-desc
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sort-up fa-lg mt-4" /><br>sort-up <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-space-shuttle fa-lg mt-4" /><br>space-shuttle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-spinner fa-lg mt-4" /><br>spinner
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-spoon fa-lg mt-4" /><br>spoon
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-square fa-lg mt-4" /><br>square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-square-o fa-lg mt-4" /><br>square-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-star fa-lg mt-4" /><br>star
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-star-half fa-lg mt-4" /><br>star-half
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-star-half-empty fa-lg mt-4" /><br>star-half-empty <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-star-half-full fa-lg mt-4" /><br>star-half-full <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-star-half-o fa-lg mt-4" /><br>star-half-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-star-o fa-lg mt-4" /><br>star-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sticky-note fa-lg mt-4" /><br>sticky-note
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sticky-note-o fa-lg mt-4" /><br>sticky-note-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-street-view fa-lg mt-4" /><br>street-view
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-suitcase fa-lg mt-4" /><br>suitcase
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sun-o fa-lg mt-4" /><br>sun-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-support fa-lg mt-4" /><br>support <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-tablet fa-lg mt-4" /><br>tablet
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-tachometer fa-lg mt-4" /><br>tachometer
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-tag fa-lg mt-4" /><br>tag
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-tags fa-lg mt-4" /><br>tags
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-tasks fa-lg mt-4" /><br>tasks
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-taxi fa-lg mt-4" /><br>taxi
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-television fa-lg mt-4" /><br>television
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-terminal fa-lg mt-4" /><br>terminal
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thumb-tack fa-lg mt-4" /><br>thumb-tack
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thumbs-down fa-lg mt-4" /><br>thumbs-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thumbs-o-down fa-lg mt-4" /><br>thumbs-o-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thumbs-o-up fa-lg mt-4" /><br>thumbs-o-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thumbs-up fa-lg mt-4" /><br>thumbs-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-ticket fa-lg mt-4" /><br>ticket
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-times fa-lg mt-4" /><br>times
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-times-circle fa-lg mt-4" /><br>times-circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-times-circle-o fa-lg mt-4" /><br>times-circle-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-tint fa-lg mt-4" /><br>tint
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-toggle-down fa-lg mt-4" /><br>toggle-down <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-toggle-left fa-lg mt-4" /><br>toggle-left <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-toggle-off fa-lg mt-4" /><br>toggle-off
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-toggle-on fa-lg mt-4" /><br>toggle-on
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-toggle-right fa-lg mt-4" /><br>toggle-right <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-toggle-up fa-lg mt-4" /><br>toggle-up <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-trademark fa-lg mt-4" /><br>trademark
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-trash fa-lg mt-4" /><br>trash
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-trash-o fa-lg mt-4" /><br>trash-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-tree fa-lg mt-4" /><br>tree
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-trophy fa-lg mt-4" /><br>trophy
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-truck fa-lg mt-4" /><br>truck
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-tty fa-lg mt-4" /><br>tty
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-tv fa-lg mt-4" /><br>tv <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-umbrella fa-lg mt-4" /><br>umbrella
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-university fa-lg mt-4" /><br>university
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-unlock fa-lg mt-4" /><br>unlock
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-unlock-alt fa-lg mt-4" /><br>unlock-alt
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-unsorted fa-lg mt-4" /><br>unsorted <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-upload fa-lg mt-4" /><br>upload
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-user fa-lg mt-4" /><br>user
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-user-plus fa-lg mt-4" /><br>user-plus
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-user-secret fa-lg mt-4" /><br>user-secret
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-user-times fa-lg mt-4" /><br>user-times
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-users fa-lg mt-4" /><br>users
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-video-camera fa-lg mt-4" /><br>video-camera
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-volume-down fa-lg mt-4" /><br>volume-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-volume-off fa-lg mt-4" /><br>volume-off
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-volume-up fa-lg mt-4" /><br>volume-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-warning fa-lg mt-4" /><br>warning <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-wheelchair fa-lg mt-4" /><br>wheelchair
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-wifi fa-lg mt-4" /><br>wifi
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-wrench fa-lg mt-4" /><br>wrench
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card 
      id="hand" 
      no-body
    >
      <div slot="header">
        Hand Icons
      </div>
      <b-card-body>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-grab-o fa-lg mt-4" /><br>hand-grab-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-lizard-o fa-lg mt-4" /><br>hand-lizard-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-o-down fa-lg mt-4" /><br>hand-o-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-o-left fa-lg mt-4" /><br>hand-o-left
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-o-right fa-lg mt-4" /><br>hand-o-right
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-o-up fa-lg mt-4" /><br>hand-o-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-paper-o fa-lg mt-4" /><br>hand-paper-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-peace-o fa-lg mt-4" /><br>hand-peace-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-pointer-o fa-lg mt-4" /><br>hand-pointer-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-rock-o fa-lg mt-4" /><br>hand-rock-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-scissors-o fa-lg mt-4" /><br>hand-scissors-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-spock-o fa-lg mt-4" /><br>hand-spock-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-stop-o fa-lg mt-4" /><br>hand-stop-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thumbs-down fa-lg mt-4" /><br>thumbs-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thumbs-o-down fa-lg mt-4" /><br>thumbs-o-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thumbs-o-up fa-lg mt-4" /><br>thumbs-o-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-thumbs-up fa-lg mt-4" /><br>thumbs-up
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card 
      id="transportation" 
      no-body
    >
      <div slot="header">
        Transportation Icons
      </div>
      <b-card-body>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-ambulance fa-lg mt-4" /><br>ambulance
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-automobile fa-lg mt-4" /><br>automobile <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bicycle fa-lg mt-4" /><br>bicycle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bus fa-lg mt-4" /><br>bus
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cab fa-lg mt-4" /><br>cab <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-car fa-lg mt-4" /><br>car
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-fighter-jet fa-lg mt-4" /><br>fighter-jet
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-motorcycle fa-lg mt-4" /><br>motorcycle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-plane fa-lg mt-4" /><br>plane
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-rocket fa-lg mt-4" /><br>rocket
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-ship fa-lg mt-4" /><br>ship
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-space-shuttle fa-lg mt-4" /><br>space-shuttle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-subway fa-lg mt-4" /><br>subway
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-taxi fa-lg mt-4" /><br>taxi
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-train fa-lg mt-4" /><br>train
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-truck fa-lg mt-4" /><br>truck
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-wheelchair fa-lg mt-4" /><br>wheelchair
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card 
      id="gender" 
      no-body
    >
      <div slot="header">
        Gender Icons
      </div>
      <b-card-body>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-genderless fa-lg mt-4" /><br>genderless
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-intersex fa-lg mt-4" /><br>intersex <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-mars fa-lg mt-4" /><br>mars
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-mars-double fa-lg mt-4" /><br>mars-double
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-mars-stroke fa-lg mt-4" /><br>mars-stroke
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-mars-stroke-h fa-lg mt-4" /><br>mars-stroke-h
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-mars-stroke-v fa-lg mt-4" /><br>mars-stroke-v
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-mercury fa-lg mt-4" /><br>mercury
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-neuter fa-lg mt-4" /><br>neuter
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-transgender fa-lg mt-4" /><br>transgender
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-transgender-alt fa-lg mt-4" /><br>transgender-alt
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-venus fa-lg mt-4" /><br>venus
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-venus-double fa-lg mt-4" /><br>venus-double
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-venus-mars fa-lg mt-4" /><br>venus-mars
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card 
      id="file-type" 
      no-body
    >
      <div slot="header">
        File Type Icons
      </div>
      <b-card-body>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file fa-lg mt-4" /><br>file
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-archive-o fa-lg mt-4" /><br>file-archive-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-audio-o fa-lg mt-4" /><br>file-audio-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-code-o fa-lg mt-4" /><br>file-code-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-excel-o fa-lg mt-4" /><br>file-excel-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-image-o fa-lg mt-4" /><br>file-image-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-movie-o fa-lg mt-4" /><br>file-movie-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-o fa-lg mt-4" /><br>file-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-pdf-o fa-lg mt-4" /><br>file-pdf-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-photo-o fa-lg mt-4" /><br>file-photo-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-picture-o fa-lg mt-4" /><br>file-picture-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-powerpoint-o fa-lg mt-4" /><br>file-powerpoint-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-sound-o fa-lg mt-4" /><br>file-sound-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-text fa-lg mt-4" /><br>file-text
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-text-o fa-lg mt-4" /><br>file-text-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-video-o fa-lg mt-4" /><br>file-video-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-word-o fa-lg mt-4" /><br>file-word-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-zip-o fa-lg mt-4" /><br>file-zip-o <span class="text-muted">(alias)</span>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card 
      id="spinner" 
      no-body
    >
      <div slot="header">
        Spinner Icons
      </div>
      <b-card-body>
        <div class="alert alert-success">
          <ul class="fa-ul">
            <li>
              <i class="fa fa-info-circle fa-li" />
              These icons work great with the <code>fa-spin</code> class.
            </li>
          </ul>
        </div>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-circle-o-notch fa-lg mt-4 fa-spin" /><br>circle-o-notch
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cog fa-lg mt-4" /><br>cog
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-gear fa-lg mt-4" /><br>gear <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-refresh fa-lg mt-4" /><br>refresh
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-spinner fa-lg mt-4" /><br>spinner
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card 
      id="form-control" 
      no-body
    >
      <div slot="header">
        Form Control Icons
      </div>
      <b-card-body>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-check-square fa-lg mt-4" /><br>check-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-check-square-o fa-lg mt-4" /><br>check-square-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-circle fa-lg mt-4" /><br>circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-circle-o fa-lg mt-4" /><br>circle-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-dot-circle-o fa-lg mt-4" /><br>dot-circle-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-minus-square fa-lg mt-4" /><br>minus-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-minus-square-o fa-lg mt-4" /><br>minus-square-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-plus-square fa-lg mt-4" /><br>plus-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-plus-square-o fa-lg mt-4" /><br>plus-square-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-square fa-lg mt-4" /><br>square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-square-o fa-lg mt-4" /><br>square-o
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card 
      id="payment" 
      no-body
    >
      <div slot="header">
        Payment Icons
      </div>
      <b-card-body>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc-amex fa-lg mt-4" /><br>cc-amex
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc-diners-club fa-lg mt-4" /><br>cc-diners-club
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc-discover fa-lg mt-4" /><br>cc-discover
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc-jcb fa-lg mt-4" /><br>cc-jcb
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc-mastercard fa-lg mt-4" /><br>cc-mastercard
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc-paypal fa-lg mt-4" /><br>cc-paypal
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc-stripe fa-lg mt-4" /><br>cc-stripe
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc-visa fa-lg mt-4" /><br>cc-visa
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-credit-card fa-lg mt-4" /><br>credit-card
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-credit-card-alt fa-lg mt-4" /><br>credit-card-alt
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-google-wallet fa-lg mt-4" /><br>google-wallet
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-paypal fa-lg mt-4" /><br>paypal
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card 
      id="chart" 
      no-body
    >
      <div slot="header">
        Chart Icons
      </div>
      <b-card-body>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-area-chart fa-lg mt-4" /><br>area-chart
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bar-chart fa-lg mt-4" /><br>bar-chart
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bar-chart-o fa-lg mt-4" /><br>bar-chart-o <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-line-chart fa-lg mt-4" /><br>line-chart
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-pie-chart fa-lg mt-4" /><br>pie-chart
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card 
      id="currency" 
      no-body
    >
      <div slot="header">
        Currency Icons
      </div>
      <b-card-body>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bitcoin fa-lg mt-4" /><br>bitcoin <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-btc fa-lg mt-4" /><br>btc
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cny fa-lg mt-4" /><br>cny <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-dollar fa-lg mt-4" /><br>dollar <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-eur fa-lg mt-4" /><br>eur
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-euro fa-lg mt-4" /><br>euro <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-gbp fa-lg mt-4" /><br>gbp
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-gg fa-lg mt-4" /><br>gg
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-gg-circle fa-lg mt-4" /><br>gg-circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-ils fa-lg mt-4" /><br>ils
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-inr fa-lg mt-4" /><br>inr
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-jpy fa-lg mt-4" /><br>jpy
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-krw fa-lg mt-4" /><br>krw
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-money fa-lg mt-4" /><br>money
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-rmb fa-lg mt-4" /><br>rmb <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-rouble fa-lg mt-4" /><br>rouble <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-rub fa-lg mt-4" /><br>rub
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-ruble fa-lg mt-4" /><br>ruble <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-rupee fa-lg mt-4" /><br>rupee <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-shekel fa-lg mt-4" /><br>shekel <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sheqel fa-lg mt-4" /><br>sheqel <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-try fa-lg mt-4" /><br>try
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-turkish-lira fa-lg mt-4" /><br>turkish-lira <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-usd fa-lg mt-4" /><br>usd
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-won fa-lg mt-4" /><br>won <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-yen fa-lg mt-4" /><br>yen <span class="text-muted">(alias)</span>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card 
      id="text-editor" 
      no-body
    >
      <div slot="header">
        Text Editor Icons
      </div>
      <b-card-body>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-align-center fa-lg mt-4" /><br>align-center
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-align-justify fa-lg mt-4" /><br>align-justify
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-align-left fa-lg mt-4" /><br>align-left
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-align-right fa-lg mt-4" /><br>align-right
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bold fa-lg mt-4" /><br>bold
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-chain fa-lg mt-4" /><br>chain <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-chain-broken fa-lg mt-4" /><br>chain-broken
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-clipboard fa-lg mt-4" /><br>clipboard
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-columns fa-lg mt-4" /><br>columns
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-copy fa-lg mt-4" /><br>copy <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cut fa-lg mt-4" /><br>cut <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-dedent fa-lg mt-4" /><br>dedent <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-eraser fa-lg mt-4" /><br>eraser
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file fa-lg mt-4" /><br>file
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-o fa-lg mt-4" /><br>file-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-text fa-lg mt-4" /><br>file-text
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-file-text-o fa-lg mt-4" /><br>file-text-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-files-o fa-lg mt-4" /><br>files-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-floppy-o fa-lg mt-4" /><br>floppy-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-font fa-lg mt-4" /><br>font
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-header fa-lg mt-4" /><br>header
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-indent fa-lg mt-4" /><br>indent
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-italic fa-lg mt-4" /><br>italic
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-link fa-lg mt-4" /><br>link
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-list fa-lg mt-4" /><br>list
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-list-alt fa-lg mt-4" /><br>list-alt
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-list-ol fa-lg mt-4" /><br>list-ol
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-list-ul fa-lg mt-4" /><br>list-ul
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-outdent fa-lg mt-4" /><br>outdent
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-paperclip fa-lg mt-4" /><br>paperclip
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-paragraph fa-lg mt-4" /><br>paragraph
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-paste fa-lg mt-4" /><br>paste <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-repeat fa-lg mt-4" /><br>repeat
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-rotate-left fa-lg mt-4" /><br>rotate-left <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-rotate-right fa-lg mt-4" /><br>rotate-right <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-save fa-lg mt-4" /><br>save <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-scissors fa-lg mt-4" /><br>scissors
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-strikethrough fa-lg mt-4" /><br>strikethrough
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-subscript fa-lg mt-4" /><br>subscript
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-superscript fa-lg mt-4" /><br>superscript
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-table fa-lg mt-4" /><br>table
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-text-height fa-lg mt-4" /><br>text-height
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-text-width fa-lg mt-4" /><br>text-width
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-th fa-lg mt-4" /><br>th
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-th-large fa-lg mt-4" /><br>th-large
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-th-list fa-lg mt-4" /><br>th-list
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-underline fa-lg mt-4" /><br>underline
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-undo fa-lg mt-4" /><br>undo
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-unlink fa-lg mt-4" /><br>unlink <span class="text-muted">(alias)</span>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card 
      id="directional" 
      no-body
    >
      <div slot="header">
        Directional Icons
      </div>
      <b-card-body>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-angle-double-down fa-lg mt-4" /><br>angle-double-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-angle-double-left fa-lg mt-4" /><br>angle-double-left
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-angle-double-right fa-lg mt-4" /><br>angle-double-right
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-angle-double-up fa-lg mt-4" /><br>angle-double-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-angle-down fa-lg mt-4" /><br>angle-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-angle-left fa-lg mt-4" /><br>angle-left
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-angle-right fa-lg mt-4" /><br>angle-right
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-angle-up fa-lg mt-4" /><br>angle-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrow-circle-down fa-lg mt-4" /><br>arrow-circle-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrow-circle-left fa-lg mt-4" /><br>arrow-circle-left
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrow-circle-o-down fa-lg mt-4" /><br>arrow-circle-o-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrow-circle-o-left fa-lg mt-4" /><br>arrow-circle-o-left
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrow-circle-o-right fa-lg mt-4" /><br>arrow-circle-o-right
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrow-circle-o-up fa-lg mt-4" /><br>arrow-circle-o-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrow-circle-right fa-lg mt-4" /><br>arrow-circle-right
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrow-circle-up fa-lg mt-4" /><br>arrow-circle-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrow-down fa-lg mt-4" /><br>arrow-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrow-left fa-lg mt-4" /><br>arrow-left
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrow-right fa-lg mt-4" /><br>arrow-right
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrow-up fa-lg mt-4" /><br>arrow-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrows fa-lg mt-4" /><br>arrows
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrows-alt fa-lg mt-4" /><br>arrows-alt
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrows-h fa-lg mt-4" /><br>arrows-h
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrows-v fa-lg mt-4" /><br>arrows-v
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-caret-down fa-lg mt-4" /><br>caret-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-caret-left fa-lg mt-4" /><br>caret-left
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-caret-right fa-lg mt-4" /><br>caret-right
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-caret-square-o-down fa-lg mt-4" /><br>caret-square-o-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-caret-square-o-left fa-lg mt-4" /><br>caret-square-o-left
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-caret-square-o-right fa-lg mt-4" /><br>caret-square-o-right
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-caret-square-o-up fa-lg mt-4" /><br>caret-square-o-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-caret-up fa-lg mt-4" /><br>caret-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-chevron-circle-down fa-lg mt-4" /><br>chevron-circle-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-chevron-circle-left fa-lg mt-4" /><br>chevron-circle-left
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-chevron-circle-right fa-lg mt-4" /><br>chevron-circle-right
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-chevron-circle-up fa-lg mt-4" /><br>chevron-circle-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-chevron-down fa-lg mt-4" /><br>chevron-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-chevron-left fa-lg mt-4" /><br>chevron-left
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-chevron-right fa-lg mt-4" /><br>chevron-right
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-chevron-up fa-lg mt-4" /><br>chevron-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-exchange fa-lg mt-4" /><br>exchange
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-o-down fa-lg mt-4" /><br>hand-o-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-o-left fa-lg mt-4" /><br>hand-o-left
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-o-right fa-lg mt-4" /><br>hand-o-right
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hand-o-up fa-lg mt-4" /><br>hand-o-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-long-arrow-down fa-lg mt-4" /><br>long-arrow-down
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-long-arrow-left fa-lg mt-4" /><br>long-arrow-left
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-long-arrow-right fa-lg mt-4" /><br>long-arrow-right
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-long-arrow-up fa-lg mt-4" /><br>long-arrow-up
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-toggle-down fa-lg mt-4" /><br>toggle-down <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-toggle-left fa-lg mt-4" /><br>toggle-left <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-toggle-right fa-lg mt-4" /><br>toggle-right <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-toggle-up fa-lg mt-4" /><br>toggle-up <span class="text-muted">(alias)</span>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card 
      id="video-player" 
      no-body
    >
      <div slot="header">
        Video Player Icons
      </div>
      <b-card-body>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-arrows-alt fa-lg mt-4" /><br>arrows-alt
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-backward fa-lg mt-4" /><br>backward
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-compress fa-lg mt-4" /><br>compress
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-eject fa-lg mt-4" /><br>eject
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-expand fa-lg mt-4" /><br>expand
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-fast-backward fa-lg mt-4" /><br>fast-backward
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-fast-forward fa-lg mt-4" /><br>fast-forward
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-forward fa-lg mt-4" /><br>forward
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-pause fa-lg mt-4" /><br>pause
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-pause-circle fa-lg mt-4" /><br>pause-circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-pause-circle-o fa-lg mt-4" /><br>pause-circle-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-play fa-lg mt-4" /><br>play
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-play-circle fa-lg mt-4" /><br>play-circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-play-circle-o fa-lg mt-4" /><br>play-circle-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-random fa-lg mt-4" /><br>random
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-step-backward fa-lg mt-4" /><br>step-backward
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-step-forward fa-lg mt-4" /><br>step-forward
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-stop fa-lg mt-4" /><br>stop
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-stop-circle fa-lg mt-4" /><br>stop-circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-stop-circle-o fa-lg mt-4" /><br>stop-circle-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-youtube-play fa-lg mt-4" /><br>youtube-play
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card 
      id="brand" 
      no-body
    >
      <div slot="header">
        Brand Icons
      </div>
      <b-card-body>
        <div class="alert alert-warning">
          <h4><i class="fa fa-warning" /> Warning!</h4>
          Apparently, Adblock Plus can remove Font Awesome brand icons with their "Remove Social
          Media Buttons" setting. We will not use hacks to force them to display. Please
          <a 
            href="https://adblockplus.org/en/bugs" 
            class="alert-link"
          >report an issue with Adblock Plus</a> if you believe this to be
          an error. To work around this, you'll need to modify the social icon class names.
        </div>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-500px fa-lg mt-4" /><br>500px
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-adn fa-lg mt-4" /><br>adn
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-amazon fa-lg mt-4" /><br>amazon
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-android fa-lg mt-4" /><br>android
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-angellist fa-lg mt-4" /><br>angellist
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-apple fa-lg mt-4" /><br>apple
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-behance fa-lg mt-4" /><br>behance
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-behance-square fa-lg mt-4" /><br>behance-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bitbucket fa-lg mt-4" /><br>bitbucket
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bitbucket-square fa-lg mt-4" /><br>bitbucket-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bitcoin fa-lg mt-4" /><br>bitcoin <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-black-tie fa-lg mt-4" /><br>black-tie
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bluetooth fa-lg mt-4" /><br>bluetooth
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-bluetooth-b fa-lg mt-4" /><br>bluetooth-b
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-btc fa-lg mt-4" /><br>btc
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-buysellads fa-lg mt-4" /><br>buysellads
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc-amex fa-lg mt-4" /><br>cc-amex
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc-diners-club fa-lg mt-4" /><br>cc-diners-club
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc-discover fa-lg mt-4" /><br>cc-discover
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc-jcb fa-lg mt-4" /><br>cc-jcb
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc-mastercard fa-lg mt-4" /><br>cc-mastercard
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc-paypal fa-lg mt-4" /><br>cc-paypal
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc-stripe fa-lg mt-4" /><br>cc-stripe
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-cc-visa fa-lg mt-4" /><br>cc-visa
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-chrome fa-lg mt-4" /><br>chrome
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-codepen fa-lg mt-4" /><br>codepen
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-codiepie fa-lg mt-4" /><br>codiepie
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-connectdevelop fa-lg mt-4" /><br>connectdevelop
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-contao fa-lg mt-4" /><br>contao
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-css3 fa-lg mt-4" /><br>css3
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-dashcube fa-lg mt-4" /><br>dashcube
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-delicious fa-lg mt-4" /><br>delicious
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-deviantart fa-lg mt-4" /><br>deviantart
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-digg fa-lg mt-4" /><br>digg
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-dribbble fa-lg mt-4" /><br>dribbble
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-dropbox fa-lg mt-4" /><br>dropbox
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-drupal fa-lg mt-4" /><br>drupal
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-edge fa-lg mt-4" /><br>edge
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-empire fa-lg mt-4" /><br>empire
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-expeditedssl fa-lg mt-4" /><br>expeditedssl
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-facebook fa-lg mt-4" /><br>facebook
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-facebook-f fa-lg mt-4" /><br>facebook-f <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-facebook-official fa-lg mt-4" /><br>facebook-official
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-facebook-square fa-lg mt-4" /><br>facebook-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-firefox fa-lg mt-4" /><br>firefox
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-flickr fa-lg mt-4" /><br>flickr
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-fonticons fa-lg mt-4" /><br>fonticons
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-fort-awesome fa-lg mt-4" /><br>fort-awesome
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-forumbee fa-lg mt-4" /><br>forumbee
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-foursquare fa-lg mt-4" /><br>foursquare
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-ge fa-lg mt-4" /><br>ge <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-get-pocket fa-lg mt-4" /><br>get-pocket
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-gg fa-lg mt-4" /><br>gg
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-gg-circle fa-lg mt-4" /><br>gg-circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-git fa-lg mt-4" /><br>git
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-git-square fa-lg mt-4" /><br>git-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-github fa-lg mt-4" /><br>github
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-github-alt fa-lg mt-4" /><br>github-alt
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-github-square fa-lg mt-4" /><br>github-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-gittip fa-lg mt-4" /><br>gittip <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-google fa-lg mt-4" /><br>google
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-google-plus fa-lg mt-4" /><br>google-plus
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-google-plus-square fa-lg mt-4" /><br>google-plus-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-google-wallet fa-lg mt-4" /><br>google-wallet
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-gratipay fa-lg mt-4" /><br>gratipay
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hacker-news fa-lg mt-4" /><br>hacker-news
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-houzz fa-lg mt-4" /><br>houzz
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-html5 fa-lg mt-4" /><br>html5
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-instagram fa-lg mt-4" /><br>instagram
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-internet-explorer fa-lg mt-4" /><br>internet-explorer
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-ioxhost fa-lg mt-4" /><br>ioxhost
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-joomla fa-lg mt-4" /><br>joomla
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-jsfiddle fa-lg mt-4" /><br>jsfiddle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-lastfm fa-lg mt-4" /><br>lastfm
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-lastfm-square fa-lg mt-4" /><br>lastfm-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-leanpub fa-lg mt-4" /><br>leanpub
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-linkedin fa-lg mt-4" /><br>linkedin
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-linkedin-square fa-lg mt-4" /><br>linkedin-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-linux fa-lg mt-4" /><br>linux
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-maxcdn fa-lg mt-4" /><br>maxcdn
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-meanpath fa-lg mt-4" /><br>meanpath
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-medium fa-lg mt-4" /><br>medium
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-mixcloud fa-lg mt-4" /><br>mixcloud
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-modx fa-lg mt-4" /><br>modx
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-odnoklassniki fa-lg mt-4" /><br>odnoklassniki
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-odnoklassniki-square fa-lg mt-4" /><br>odnoklassniki-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-opencart fa-lg mt-4" /><br>opencart
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-openid fa-lg mt-4" /><br>openid
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-opera fa-lg mt-4" /><br>opera
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-optin-monster fa-lg mt-4" /><br>optin-monster
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-pagelines fa-lg mt-4" /><br>pagelines
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-paypal fa-lg mt-4" /><br>paypal
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-pied-piper fa-lg mt-4" /><br>pied-piper
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-pied-piper-alt fa-lg mt-4" /><br>pied-piper-alt
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-pinterest fa-lg mt-4" /><br>pinterest
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-pinterest-p fa-lg mt-4" /><br>pinterest-p
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-pinterest-square fa-lg mt-4" /><br>pinterest-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-product-hunt fa-lg mt-4" /><br>product-hunt
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-qq fa-lg mt-4" /><br>qq
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-ra fa-lg mt-4" /><br>ra <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-rebel fa-lg mt-4" /><br>rebel
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-reddit fa-lg mt-4" /><br>reddit
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-reddit-alien fa-lg mt-4" /><br>reddit-alien
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-reddit-square fa-lg mt-4" /><br>reddit-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-renren fa-lg mt-4" /><br>renren
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-safari fa-lg mt-4" /><br>safari
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-scribd fa-lg mt-4" /><br>scribd
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-sellsy fa-lg mt-4" /><br>sellsy
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-share-alt fa-lg mt-4" /><br>share-alt
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-share-alt-square fa-lg mt-4" /><br>share-alt-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-shirtsinbulk fa-lg mt-4" /><br>shirtsinbulk
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-simplybuilt fa-lg mt-4" /><br>simplybuilt
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-skyatlas fa-lg mt-4" /><br>skyatlas
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-skype fa-lg mt-4" /><br>skype
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-slack fa-lg mt-4" /><br>slack
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-slideshare fa-lg mt-4" /><br>slideshare
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-soundcloud fa-lg mt-4" /><br>soundcloud
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-spotify fa-lg mt-4" /><br>spotify
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-stack-exchange fa-lg mt-4" /><br>stack-exchange
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-stack-overflow fa-lg mt-4" /><br>stack-overflow
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-steam fa-lg mt-4" /><br>steam
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-steam-square fa-lg mt-4" /><br>steam-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-stumbleupon fa-lg mt-4" /><br>stumbleupon
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-stumbleupon-circle fa-lg mt-4" /><br>stumbleupon-circle
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-tencent-weibo fa-lg mt-4" /><br>tencent-weibo
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-trello fa-lg mt-4" /><br>trello
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-tripadvisor fa-lg mt-4" /><br>tripadvisor
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-tumblr fa-lg mt-4" /><br>tumblr
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-tumblr-square fa-lg mt-4" /><br>tumblr-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-twitch fa-lg mt-4" /><br>twitch
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-twitter fa-lg mt-4" /><br>twitter
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-twitter-square fa-lg mt-4" /><br>twitter-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-usb fa-lg mt-4" /><br>usb
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-viacoin fa-lg mt-4" /><br>viacoin
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-vimeo fa-lg mt-4" /><br>vimeo
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-vimeo-square fa-lg mt-4" /><br>vimeo-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-vine fa-lg mt-4" /><br>vine
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-vk fa-lg mt-4" /><br>vk
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-wechat fa-lg mt-4" /><br>wechat <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-weibo fa-lg mt-4" /><br>weibo
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-weixin fa-lg mt-4" /><br>weixin
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-whatsapp fa-lg mt-4" /><br>whatsapp
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-wikipedia-w fa-lg mt-4" /><br>wikipedia-w
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-windows fa-lg mt-4" /><br>windows
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-wordpress fa-lg mt-4" /><br>wordpress
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-xing fa-lg mt-4" /><br>xing
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-xing-square fa-lg mt-4" /><br>xing-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-y-combinator fa-lg mt-4" /><br>y-combinator
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-y-combinator-square fa-lg mt-4" /><br>y-combinator-square <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-yahoo fa-lg mt-4" /><br>yahoo
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-yc fa-lg mt-4" /><br>yc <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-yc-square fa-lg mt-4" /><br>yc-square <span class="text-muted">(alias)</span>
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-yelp fa-lg mt-4" /><br>yelp
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-youtube fa-lg mt-4" /><br>youtube
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-youtube-play fa-lg mt-4" /><br>youtube-play
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-youtube-square fa-lg mt-4" /><br>youtube-square
          </b-col>
        </b-row>
        <div class="alert alert-success mt-4">
          <ul class="margin-bottom-none padding-left-lg">
            <li>All brand icons are trademarks of their respective owners.</li>
            <li>The use of these trademarks does not indicate endorsement of the trademark holder by Font Awesome, nor vice versa.</li>
            <li>Brand icons should only be used to represent the company or product to which they refer.</li>
          </ul>
        </div>
      </b-card-body>
    </b-card>

    <b-card 
      id="medical" 
      no-body
    >
      <div slot="header">
        Medical Icons
      </div>
      <b-card-body>
        <b-row class="text-center">
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-ambulance fa-lg mt-4" /><br>ambulance
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-h-square fa-lg mt-4" /><br>h-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-heart fa-lg mt-4" /><br>heart
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-heart-o fa-lg mt-4" /><br>heart-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-heartbeat fa-lg mt-4" /><br>heartbeat
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-hospital-o fa-lg mt-4" /><br>hospital-o
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-medkit fa-lg mt-4" /><br>medkit
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-plus-square fa-lg mt-4" /><br>plus-square
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-stethoscope fa-lg mt-4" /><br>stethoscope
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-user-md fa-lg mt-4" /><br>user-md
          </b-col>
          <b-col 
            cols="6" 
            sm="4" 
            md="3" 
            lg="2"
          >
            <i class="fa fa-wheelchair fa-lg mt-4" /><br>wheelchair
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'FontAwesome'
}
</script>
